import { MuiCardMedia } from '@/components/blocks/MuiCardMedia';
import { PROMOTION_TYPES } from '@/data/constants/promoIconConstants';
import { ProductType } from '@/data/types/Product';
import { usePromoIconsWithStyleAndUrls } from '@/data/utils/usePromoIcons';
import { setClassName } from '@/data/utils/usePromoIcons/promoLists';
import { Box, Stack } from '@mui/material';
import { memo, useMemo } from 'react';

export const PromoBadges = memo(
	({ product, exclude }: { product: ProductType; exclude?: string[] }) => {
		const { promotions } = usePromoIconsWithStyleAndUrls({ product });

		const finalOrderPromotions = useMemo(() => {
			const hasGR = promotions.some((promo) => promo.identifier === PROMOTION_TYPES.PROMOICON_GR);
			const hasFP = promotions.some((promo) => promo.identifier === PROMOTION_TYPES.PROMOICON_FP);

			let result = promotions;
			if (hasGR) {
				result = promotions.filter((p) => p.identifier === PROMOTION_TYPES.PROMOICON_GR);
			} else if (hasFP) {
				result = promotions.filter((p) => !p.identifier?.startsWith(PROMOTION_TYPES.PROMORIBBON_NXM_));
			}
			if (exclude?.length) {
				result = result.filter((p) => !exclude.includes(p.identifier));
			}
			return result;
		}, [promotions, exclude]);

		if (!finalOrderPromotions.length) {
			return null;
		}

	return (
		<Stack direction={'row'} flexWrap={'wrap'}>
			{finalOrderPromotions.map((promotion) => (
				<Box sx={{ height: '23px', mr: '5px', flexWrap: 'wrap' }} key={promotion.identifier}>
					<MuiCardMedia
						component="img"
						image={promotion.iconPlp ?? promotion.icon}
						sx={promotion.badgesStylesPlp ?? promotion.badgesStyles}
						title={promotion.identifier}
						className={setClassName(promotion.identifier)}
					></MuiCardMedia>
				</Box>
			))}
		</Stack>
	);
});
